import { ThemeProvider, useMediaQuery } from '@mui/material';
import { Box, styled, useTheme } from '@mui/system';
import { Suspense } from 'app/components';
import { sidenavCompactWidth, sideNavWidth } from 'app/utils/constant';
import React, { useEffect, useRef } from 'react';
import Scrollbar from 'react-perfect-scrollbar';
import { Outlet } from 'react-router-dom';
import Footer from '../../Footer';
import SidenavTheme from '../../Theme/SidenavTheme/SidenavTheme';
import Layout1Sidenav from './Layout1Sidenav';
import Layout1Topbar from './Layout1Topbar';
import Layout0Topbar from './Layout0Topbar';
import { useDispatch,useSelector } from 'react-redux';
import { setMode } from 'app/redux/actions/SettingActions';
import { topBarHeight } from 'app/utils/constant';

import '../../../../styles/profile-layout.scss';

const Layout1Root = styled(Box)(({ theme, logged}) =>({paddingTop: logged ? 0 : topBarHeight}));
const ContentBox = styled(Box)(({padding}) => ({ padding }));
const LayoutContainer = styled(Box)(({ width }) => ({ marginLeft: width }));

const Profile = ({ padding=0, component }) => {
  const settings = useSelector(store=>store.settings);
  const auth = useSelector(store=>store.auth);
  
  const { layout1Settings } = settings;
  const topbarTheme = settings.themes[layout1Settings.topbar.theme];
  const {
    leftSidebar: { mode: sidenavMode, show: showSidenav },
  } = layout1Settings;

  const getSidenavWidth = () => {
    
     if( !auth?.isLogged )
      return '0px';
    
    switch (sidenavMode) {
      case 'full':
        return sideNavWidth;

      case 'compact':
        return sidenavCompactWidth;

      default:
        return '0px';
    }
  };

  const sidenavWidth = getSidenavWidth();
  
  //const [sidenavWidth, setSidenavWidth] = useState(0);
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();
  const ref = useRef({ isMdScreen, settings });
  const layoutClasses = `cnt-layout-profile theme-${theme.palette.type}`;

  useEffect(() => {
    let { settings } = ref.current;
   // let sidebarMode = settings.layout1Settings.leftSidebar.mode;
    if (settings.layout1Settings.leftSidebar.show) {
      let mode = isMdScreen || !auth?.isLogged ? 'close' : "compact";
      //updateSettings({ layout1Settings: { leftSidebar: { mode } } });
      dispatch(setMode(mode));
     // setSidenavWidth(getSidenavWidth(auth?.isLogged, mode));
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMdScreen,auth?.isLogged]);

  return (
    <Layout1Root className={layoutClasses} logged={auth?.isLogged ? 1 : 0}>
      {auth?.isLogged && showSidenav && sidenavMode !== 'close' && (
        <SidenavTheme>
          <Layout1Sidenav source="profile" />
        </SidenavTheme>
      )}

      <LayoutContainer className="layout-container" width={sidenavWidth}>
        {layout1Settings.topbar.show && layout1Settings.topbar.fixed && (
          <ThemeProvider theme={topbarTheme}>
            {auth?.isLogged ? <Layout1Topbar fixed={false} className="elevation-z8" /> : <Layout0Topbar fixed={true} className="elevation-z8" />}
          </ThemeProvider>
        )}

        {settings.perfectScrollbar && (
          <Scrollbar className="styled-scroll-bar">
            <ContentBox padding={padding} id="ContentBox" className={`content-box-profile`}>
          
            {layout1Settings.topbar.show && !layout1Settings.topbar.fixed && (
              <ThemeProvider theme={topbarTheme}>
                <Layout1Topbar />
              </ThemeProvider>
            )}
            <Box flexGrow={1} position="relative">
              <Suspense>
                {component ? component : <Outlet />}
              </Suspense>
            </Box>
            </ContentBox>
            {settings.footer.show && !settings.footer.fixed && <Footer />}
          </Scrollbar>
        )}

        {!settings.perfectScrollbar && (
          <ContentBox padding={padding} id="ContentBox" className={`content-box-profile`}>
            {layout1Settings.topbar.show && !layout1Settings.topbar.fixed && (
              <ThemeProvider theme={topbarTheme}>
                <Layout1Topbar />
              </ThemeProvider>
            )}

            <Box flexGrow={1} position="relative">
              <Suspense>
                {component ? component : <Outlet />}
              </Suspense>
            </Box>

            {settings.footer.show && !settings.footer.fixed && <Footer />}
          </ContentBox>
        )}

        {settings.footer.show && settings.footer.fixed && <Footer />}

      </LayoutContainer>

    </Layout1Root>
  );
};

export default React.memo(Profile);
